import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{attrs:{"outlined":""}},[_c(VList,[_c(VListItem,[_c(VListItemContent,[_c(VListItemSubtitle,[_vm._v(_vm._s(_vm.$t('insurerStatus')))]),_c(VListItemTitle,[_vm._v(_vm._s(_vm.$t(`labels.${_vm.policy.insurer_status}`)))])],1)],1),_c(VDivider),_c(VListItem,[_c(VListItemTitle,[_vm._v(_vm._s(_vm.$t('insurerDecision')))]),(!_vm.readOnly)?_c(VListItemAction,[_c(VSwitch,{attrs:{"color":"success"},model:{value:(_vm.decision),callback:function ($$v) {_vm.decision=$$v},expression:"decision"}})],1):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }